import "../sparkle_namespace.js";
import "./modal.js";
import "../../application/responsive/index.js";

window.Sparkle ??= {};

Sparkle.VideoModal = class VideoModal {
  constructor(headerText, videoUrl, captionText) {
    this.handleMobileBreakpointEnter = this.handleMobileBreakpointEnter.bind(this);
    this.handleMobileBreakpointExit = this.handleMobileBreakpointExit.bind(this);
    this.handleVideoPlay = this.handleVideoPlay.bind(this);
    this.handleVideoEnded = this.handleVideoEnded.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.videoElement = this.videoElement.bind(this);
    this.captionElement = this.captionElement.bind(this);
    this.triggerEndedEvent = this.triggerEndedEvent.bind(this);
    this.modal = new Modal({
      class: "video-modal video-modal--default",
      header: jQuery("<h3>").append(headerText),
      body: this.videoElement(videoUrl) + this.captionElement(captionText),
    });

    // BEHAVIOUR

    this.modal.container.on("hide", this.handleHideModal);

    // HTML5 video element events
    this.modal.container.find("video").on("play", this.handleVideoPlay);
    this.modal.container.find("video").on("ended", this.handleVideoEnded);

    // Embeded video element event
    this.modal.container.on("embed:play.sparkle", this.handleVideoPlay);
    this.modal.container.on("embed:ended.sparkle", this.handleVideoEnded);

    new Sparkle.Responsive.mediaCheck({
      media: "(max-width:" + Sparkle.Responsive.Entities.mobile + "px)",
      entry: this.handleMobileBreakpointEnter,
      exit: this.handleMobileBreakpointExit,
    });

    // INITIALIZE

    this.modal.show();
  }

  // EVENT HANDLERS

  handleMobileBreakpointEnter(event) {
    this.modal.container.addClass("video-modal--bare");
    return this.modal.container.removeClass("video-modal--default");
  }

  handleMobileBreakpointExit(event) {
    this.modal.container.addClass("video-modal--default");
    return this.modal.container.removeClass("video-modal--bare");
  }

  handleVideoPlay(event) {
    this.player = event.target;
    return (this.pendingEndedEvent = true);
  }

  handleVideoEnded(event) {
    this.pendingEndedEvent = false;
    return this.modal.hide();
  }

  handleHideModal(event) {
    if (this.pendingEndedEvent) {
      this.triggerEndedEvent();
    }
    return this.modal.destroy();
  }

  // HELPERS

  videoElement(videoUrl) {
    if (/\.mp4$/.test(videoUrl)) {
      return (
        '<video autobuffer="autobuffer" autoplay="autoplay" controls="controls" style="height: 100%; width: 100%"><source src="' +
        videoUrl +
        '" type="video/mp4" /></video>'
      );
    } else {
      return (
        '<iframe type="text/html" class="youtube-player" width="100%" height="360" src="' +
        videoUrl +
        '" frameborder="0" referrerpolicy="no-referrer-when-downgrade"></iframe>'
      );
    }
  }

  captionElement(text) {
    if (text != null && text.trim() !== "") {
      return '<div class="video-modal__caption">' + text + "</div>";
    } else {
      return "";
    }
  }

  triggerEndedEvent() {
    if (jQuery(this.player).is("video")) {
      return jQuery(this.player).trigger("ended");
    } else {
      return jQuery(this.player).trigger("embed:ended.sparkle");
    }
  }
};
